<template>
  <div class="border-box-5" :ref="ref">
    <svg class="border-svg-container" :width="mergedWidth" :height="mergedHeight">
<!--      // viewBox 重点在 此属性-->
      <path :d="`M 15 0 L ${mergedWidth/4*3 + 15} 0 L ${mergedWidth/4*3+25} 15 L ${mergedWidth} 15 L ${mergedWidth} ${mergedHeight - 15} L ${mergedWidth - 15} ${mergedHeight} L 15 ${mergedHeight} L 0 ${mergedHeight - 15} L 0 15 Z`"
            :fill="backgroundColor"
            :stroke="mergedColor[0]"/>
      <g>
        <path :d="`M ${mergedWidth/4 * 3+20} 2.5 h 5 l6,8 h-5 Z`" opacity="0.8" :stroke="mergedColor[1]" :fill="mergedColor[1]"/>
        <path :d="`M ${mergedWidth/4 *3+30} 2.5 h 5 l6,8 h-5 Z`" opacity="0.7" :stroke="mergedColor[1]" :fill="mergedColor[1]"/>
        <path :d="`M ${mergedWidth/4*3+40} 2.5 h 5 l6,8 h-5 Z`" opacity="0.6" :stroke="mergedColor[1]" :fill="mergedColor[1]"/>
        <path :d="`M ${mergedWidth/4*3+50} 2.5 h 5 l6,8 h-5 Z`" opacity="0.4" :stroke="mergedColor[1]" :fill="mergedColor[1]"/>
        <path :d="`M ${mergedWidth/4*3+60} 2.5 h 5 l6,8 h-5 Z`" opacity="0.2" :stroke="mergedColor[1]" :fill="mergedColor[1]"/>
      </g>
    </svg>
    <div class="border-box-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import autoResize from '@jiaminghi/data-view/src/mixin/autoResize'
import { deepMerge } from '@jiaminghi/charts/lib/util/index'
import { deepClone } from '@jiaminghi/c-render/lib/plugin/util'

export default {
  name: 'BorderBox5',
  mixins: [autoResize],
  props: {
    color: {
      type: Array,
      default: () => ([]),
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    boxWidth:{
      type:Number,
      default:0
    },
    boxHeight:{
      type:Number,
      default:0
    },
    resize:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      ref: 'border-box-5',
      defaultColor: ['#00d5ff', '#088ee3'],
      mergedColor: [],
      mergedWidth: 0,
      mergedHeight: 0,
    }
  },
  watch: {
    color() {
      const {mergeColor} = this
      mergeColor()
    },
    width:{
      immediate:true,
      deep:true,
      handler() {
        if (!this.boxWidth) {
          this.mergedWidth = this.width
        }
      }
    },
    boxWidth:{
      immediate:true,
      deep:true,
      handler(val) {
        if (val) {
          this.mergedWidth = val
        }
      }
    },
    resize(val) {
      if (val) {
        this.initWH()
      }
    },
    height:{
      immediate:true,
      deep:true,
      handler() {
        if (!this.boxHeight) {
          this.mergedHeight = this.height - 1
        }
      }
    },
    boxHeight:{
      immediate:true,
      deep:true,
      handler(val) {
        if (val) {
          this.mergedHeight = val
        }
      }
    }
  },
  methods: {
    mergeColor() {
      const {color, defaultColor} = this
      this.mergedColor = deepMerge(deepClone(defaultColor, true), color || [])
    }
  },
  mounted() {
    const {mergeColor}=this
    mergeColor()
  },
}
</script>

<style scoped lang="less">
  .border-box-5{
    position: relative;
    width: 100%;
    height: 100%;

  .border-svg-container{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
  }
  .border-box-content{
    position: relative;
    width: 100%;
    height: 100%;
    //padding: 0.125rem;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/border/border-box-5/main.vue